export default __webpack_public_path__ + "static/media/orthrus.a151cb6e.png";